module.exports = __webpack_public_path__ + "img/vi_VN.1fd29e5.jpg";